import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 1,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 px-6 py-4 md:px-12 flex justify-between items-center transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-md shadow-sm text-charcoal py-4' : 'bg-transparent text-white py-6'}`} data-id="element-161">
      <a href="#inicio" className="flex items-center" data-id="element-162">
        <img src="https://cdn.magicpatterns.com/uploads/n8RBnThdh9nPmMgxYCad5H/PORTADAS_BLOGS_(3).png" alt="Aventuras por el Mundo" className={`w-auto object-contain transition-all duration-500 ease-out ${scrolled ? 'h-14 md:h-16 brightness-0 opacity-90' : 'h-20 md:h-28 brightness-0 invert'}`} data-id="element-163" />
      </a>
      <div className="hidden md:flex items-center space-x-8 font-sans text-xs uppercase tracking-[0.1em] font-medium" data-id="element-164">
        <a href="#inicio" className="hover:text-rose-primary transition-colors" data-id="element-165">
          Inicio
        </a>
        <a href="#experiencias" className="hover:text-rose-primary transition-colors" data-id="element-166">
          Experiencias
        </a>
        <a href="#nosotras" className="hover:text-rose-primary transition-colors" data-id="element-167">
          Nosotras
        </a>
        <a href="#contacto" className="hover:text-rose-primary transition-colors" data-id="element-168">
          Contacto
        </a>
        <a href="#contacto" className={`px-5 py-2 rounded-full transition-colors border ${scrolled ? 'bg-[#D07C9D] text-white border-[#D07C9D] hover:bg-[#b96a89]' : 'bg-white/10 backdrop-blur-sm border-white/30 hover:bg-white hover:text-charcoal'}`} data-id="element-169">
          Reserva
        </a>
      </div>
    </motion.nav>;
}